import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useEffect, useImperativeHandle, useRef, useState, } from 'react';
/**
 * Adds a scroller element, used to attach an extra scroller on top of the results table
 * @param widthElRef to sync width of this scrolled to original overflow element
 * @param scrollElRef original overflow container element
 * @param ref provides an onScroll handler for the original overflow element to affect this top scroller
 * onScroll may need to be wrapped in a useCallback
 */
const TopScroller = forwardRef(({ widthElRef, scrollElRef }, ref) => {
    const topScrollerRef = useRef(null);
    const [tableWidth, setTableWidth] = useState(0);
    useEffect(() => {
        if (widthElRef.current) {
            setTableWidth(widthElRef.current.clientWidth);
        }
    }, [widthElRef]);
    useImperativeHandle(ref, () => ({
        onScroll() {
            if (topScrollerRef.current && scrollElRef.current) {
                topScrollerRef.current.scrollLeft = scrollElRef.current.scrollLeft;
            }
        },
    }));
    const onScroll = () => {
        if (scrollElRef.current && topScrollerRef.current) {
            // eslint-disable-next-line no-param-reassign
            scrollElRef.current.scrollLeft = topScrollerRef.current.scrollLeft;
        }
    };
    return (_jsx("div", { className: "mt-0 overflow-x-auto", ref: topScrollerRef, onScroll: onScroll, children: _jsx("div", { style: {
                width: tableWidth,
                minHeight: 20,
            } }) }));
});
export default TopScroller;
//# sourceMappingURL=TopScroller.js.map